<template>
  <div>
    <CrudList
      title="Días de disponibilidad"
      storeName="Availability_days"
      parentStoreName="Professionals"
      parentUrlKey="professional_id"
      labelAddNew="Agregar nueva Availability Day"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      canSearch
    >
      <template v-slot:availability_hour="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-btn color="primary" class="mr-4" v-on:click="$router.push('/admin/professionals/'+item.professional_id+'/availability_days/'+item.id+'/availability_hours')">
              Hora de disponibilidad
            </v-btn></v-col
          >
        </v-row>
      </template>
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList }
};
</script>
